export function bayardMagazineGuard(to, from, next) {
    if (!!to.query.bayardMagazine) {
        window.location.replace(process.env.VUE_APP_ILE_PRODUCT_URL);
        return false;
    }
    next();
}